// interactive-activity 环境配置
const interactiveActivityEnvConfig = {
  test: {
    urls: [
      'https://h5-test.cheweijia.com/qs/admin/cwj-interactive-activity/test/lowcode/render/default/view.js',
      'https://h5-test.cheweijia.com/qs/admin/cwj-interactive-activity/test/lowcode/render/default/view.css',
    ],
    editUrls: [
      'https://h5-test.cheweijia.com/qs/admin/cwj-interactive-activity/test/lowcode/view.js',
      'https://h5-test.cheweijia.com/qs/admin/cwj-interactive-activity/test/lowcode/view.css',
    ],
    advancedUrls: {
      default: [
        'https://h5-test.cheweijia.com/qs/admin/cwj-interactive-activity/test/lowcode/render/default/view.js',
        'https://h5-test.cheweijia.com/qs/admin/cwj-interactive-activity/test/lowcode/render/default/view.css',
      ],
    },
  },
  test2: {
    urls: [
      'https://h5-test.cheweijia.com/qs/admin/cwj-interactive-activity/test2/lowcode/render/default/view.js',
      'https://h5-test.cheweijia.com/qs/admin/cwj-interactive-activity/test2/lowcode/render/default/view.css',
    ],
    editUrls: [
      'https://h5-test.cheweijia.com/qs/admin/cwj-interactive-activity/test2/lowcode/view.js',
      'https://h5-test.cheweijia.com/qs/admin/cwj-interactive-activity/test2/lowcode/view.css',
    ],
    advancedUrls: {
      default: [
        'https://h5-test.cheweijia.com/qs/admin/cwj-interactive-activity/test2/lowcode/render/default/view.js',
        'https://h5-test.cheweijia.com/qs/admin/cwj-interactive-activity/test2/lowcode/render/default/view.css',
      ],
    },
  },
  gray: {
    urls: [
      'https://h5-gray.cheweijia.com/qs/admin/cwj-interactive-activity/lowcode/render/default/view.js',
      'https://h5-gray.cheweijia.com/qs/admin/cwj-interactive-activity/lowcode/render/default/view.css',
    ],
    editUrls: [
      'https://h5-gray.cheweijia.com/qs/admin/cwj-interactive-activity/lowcode/view.js',
      'https://h5-gray.cheweijia.com/qs/admin/cwj-interactive-activity/lowcode/view.css',
    ],
    advancedUrls: {
      default: [
        'https://h5-gray.cheweijia.com/qs/admin/cwj-interactive-activity/lowcode/render/default/view.js',
        'https://h5-gray.cheweijia.com/qs/admin/cwj-interactive-activity/lowcode/render/default/view.css',
      ],
    },
  },
  prod: {
    urls: [
      'https://h5.cheweijia.com/qs/admin/cwj-interactive-activity/lowcode/render/default/view.js',
      'https://h5.cheweijia.com/qs/admin/cwj-interactive-activity/lowcode/render/default/view.css',
    ],
    editUrls: [
      'https://h5.cheweijia.com/qs/admin/cwj-interactive-activity/lowcode/view.js',
      'https://h5.cheweijia.com/qs/admin/cwj-interactive-activity/lowcode/view.css',
    ],
    advancedUrls: {
      default: [
        'https://h5.cheweijia.com/qs/admin/cwj-interactive-activity/lowcode/render/default/view.js',
        'https://h5.cheweijia.com/qs/admin/cwj-interactive-activity/lowcode/render/default/view.css',
      ],
    },
  },
}

// 根据环境获取 interactive-activity 配置
const getInteractiveActivityConfig = (env) => {
  const config = interactiveActivityEnvConfig[env] || interactiveActivityEnvConfig.prod
  return {
    package: 'cwj-interactive-activity',
    version: '0.0.1',
    library: 'cwj-interactive-activity',
    urls: config.urls,
    editUrls: config.editUrls,
    advancedUrls: config.advancedUrls,
    advancedEditUrls: {},
  }
}

// prod 配置作为默认值
const prodInteractiveActivityConfig = getInteractiveActivityConfig('prod')

// 根据环境返回 getDefaultConfig
// env: 'test' | 'test2' | 'gray' | 'prod'
export const getDefaultConfigByEnv = (env) => {
  return (data) => getDefaultConfig(data, getInteractiveActivityConfig(env))
}

export const getDefaultConfig = (data = {}, interactiveActivityConfig = null) => {
  return {
    type: 0,
    shareConfigList: [],
    checkList: [],
    title: '匹配样式',
    statisticalCode: '',
    ui: {
      packageJson: [
        {
          package: 'moment',
          version: '2.24.0',
          urls: ['https://g.alicdn.com/mylib/moment/2.24.0/min/moment.min.js'],
          library: 'moment',
        },
        {
          package: 'lodash',
          library: '_',
          urls: ['https://g.alicdn.com/platform/c/lodash/4.6.1/lodash.min.js'],
        },
        {
          title: 'fusion组件库',
          package: '@alifd/next',
          version: '1.26.4',
          urls: [
            'https://g.alicdn.com/code/lib/alifd__next/1.26.4/next.min.css',
            'https://g.alicdn.com/code/lib/alifd__next/1.26.4/next-with-locales.min.js',
          ],
          library: 'Next',
        },
        interactiveActivityConfig || prodInteractiveActivityConfig,
      ],
      schemaJson: {
        version: '1.0.0',
        componentsMap: [
          {
            devMode: 'lowCode',
            componentName: 'Page',
          },
          {
            package: 'cwj-interactive-activity',
            version: '0.0.6-alpha.1',
            exportName: 'ActivityList',
            main: 'src/index.tsx',
            destructuring: true,
            subName: '',
            componentName: 'ActivityList',
          },
          {
            package: 'cwj-interactive-activity',
            version: '0.0.6-alpha.1',
            exportName: 'ActivityImage',
            main: 'src/index.tsx',
            destructuring: true,
            subName: '',
            componentName: 'ActivityImage',
          },
          {
            package: 'cwj-interactive-activity',
            version: '0.0.6-alpha.1',
            exportName: 'ActivityBrandBottom',
            main: 'src/index.tsx',
            destructuring: true,
            subName: '',
            componentName: 'ActivityBrandBottom',
          },
        ],
        componentsTree: [
          {
            componentName: 'Page',
            id: 'node_dockcviv8fo1',
            props: {
              ref: 'outerView',
              style: {
                'min-height': '100vh',
                paddingTop: '96px',
                paddingBottom: '100px',
                backgroundColor: '#f5f5f5',
              },
              title: '匹配样式',
              type: 0,
              noBackApp: false,
            },
            docId: 'doclaqkk3b9',
            fileName: '/',
            state: {
              text: {
                type: 'JSExpression',
                value: '"outer"',
              },
              isShowDialog: {
                type: 'JSExpression',
                value: 'false',
              },
            },
            css: '',
            lifeCycles: {
              componentDidMount: {
                type: 'JSFunction',
                value:
                  "function componentDidMount() {\n  console.log('did mount');\n}",
              },
              componentWillUnmount: {
                type: 'JSFunction',
                value:
                  "function componentWillUnmount() {\n  console.log('will unmount');\n}",
              },
            },
            methods: {},
            originCode:
              "class LowcodeComponent extends Component { \nonClick() { console.log('click') \n} \n}",
            hidden: false,
            title: '',
            isLocked: false,
            condition: true,
            conditionGroup: '',
            children: [
              {
                componentName: 'ActivityImage',
                id: 'node_ocm8h6t9bh2',
                props: {
                  src: 'https://server-resource-testv2.cheweijia.com/public/market_share_pic/bcb47fd0f452408d921a585677c32caf/95c8d7f350cc4476bb9fad55f6b3c3bc.png',
                  isFixed: false,
                  isDefault: 1,
                  remark: '',
                  style: {
                    position: 'fixed',
                    zIndex: '100',
                    top: '0px',
                  },
                },
                hidden: false,
                title: '',
                isLocked: false,
                condition: true,
                conditionGroup: '',
              },
              {
                componentName: 'ActivityImage',
                id: 'node_ocm8h6t9bh3',
                props: {
                  src: 'https://server-resource-testv2.cheweijia.com/public/market_share_pic/a0fe0aa2da794bc1af5457e2cb073d29/e5420ee5593a4dd6872918acdb5f957c.png',
                  isFixed: false,
                  isDefault: 1,
                  remark: '',
                  style: {
                    marginTop: '0px',
                  },
                },
                hidden: false,
                title: '',
                isLocked: false,
                condition: true,
                conditionGroup: '',
              },
              {
                componentName: 'ActivityList',
                id: 'node_ocm8h6t9bh1',
                props: {
                  businessInfo: {
                    listType: 2,
                    listId: 2538,
                    businessType: 500,
                    rental: 1,
                  },
                  list: [],
                  backgroundColor: '#F5F5F5',
                  showType: 1,
                  remark: '',
                  listNum: 10,
                  jumpType: 1,
                  showTwoColumn: false,
                  cityGroupType: 0,
                  headerTitle: data?.headerTitle || '',
                  currentCity: { ...data },
                  otherCityList: [],
                },
                hidden: false,
                title: '',
                isLocked: false,
                condition: true,
                conditionGroup: '',
              },
              {
                componentName: 'ActivityBrandBottom',
                id: 'node_ocm8h6t9bh4',
                props: {},
                hidden: false,
                title: '',
                isLocked: false,
                condition: true,
                conditionGroup: '',
              },
              {
                componentName: 'ActivityImage',
                id: 'node_ocm8h6t9bh5',
                props: {
                  src: 'https://server-resource-testv2.cheweijia.com/public/market_share_pic/47278c9d7b2a4accabacf6a568982698/fc768d3cee0441a9b9b0c0982f31bd7a.png',
                  isFixed: true,
                  isDefault: 1,
                  remark: '',
                },
                hidden: false,
                title: '',
                isLocked: false,
                condition: true,
                conditionGroup: '',
              },
            ],
          },
        ],
        i18n: {},
      },
    },
    logic: {},
  }
}
